import { apiClient } from "@/http";
import { apiRoutes } from "./apiRoutes";

export type ServerEnvironment = "local" | "dev" | "prod";

export type ServerInfo = {
  environment: ServerEnvironment;
  version: string;
  capabilities: { training_mask_generation_enabled: boolean };
};

type GetServerInfoOptions = {
  signal?: AbortSignal;
};

// 배포 환경과 태그는 이미지 수명 동안 바뀌지 않는다. 요청 횟수와 세션 경계는 앱 컨트롤러가
// 소유한다. API 함수는 인증된 GET 계약과 취소 신호만 전달한다.
export async function getServerInfo(options: GetServerInfoOptions = {}): Promise<ServerInfo> {
  const response = await apiClient.get<ServerInfo>(apiRoutes.server.info, {
    signal: options.signal,
  });
  if (typeof response.data.capabilities?.training_mask_generation_enabled !== "boolean") {
    throw new Error("Invalid server capability response.");
  }
  return response.data;
}
